import { COMMON_ERROR, CLEAR_ERROR } from "./ApplicationDetailsErrorTypes";

const initialState = {
    errorMessage: null,
    errorType: null,
    errorShown: false, // Track if error has been shown
    errorCount: 0,     // Track number of errors
    lastErrorTime: null // Track when last error occurred
};

const errorReducer = (state = initialState, action) => {
    switch(action.type) {
        case COMMON_ERROR: {
            // Only show error if:
            const now = Date.now();
            const timeSinceLastError = state.lastErrorTime ? now - state.lastErrorTime : Infinity;
            const shouldShowError = !state.errorShown || 
                                  timeSinceLastError > 20000 || 
                                  state.errorType !== action.payload.errorType;

            if (shouldShowError) {
                return {
                    ...state,
                    errorMessage: action.payload.message,
                    errorType: action.payload.errorType,
                    errorShown: shouldShowError,
                    errorCount: state.errorCount + 1,
                    lastErrorTime: now
                };
            } else {
                // Just increment count, don't show new error
                return {
                    ...state,
                    errorCount: state.errorCount + 1
                };
            }
        }

        case CLEAR_ERROR:
            return {
                ...state,
                errorMessage: null,
                errorType: null,
                errorShown: false
            };

        default:
            return state;
    }
}

export default errorReducer;